export default __webpack_public_path__ + "static/media/add-user.8ba3f100.svg";